import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';

import { TimePicker } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import MenuItem from '@material-ui/core/MenuItem';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';

import { CSSTransitionGroup } from 'react-transition-group';

import validate from './validate';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

const parseTime = (value) => {
  if (value instanceof Date) return value;

  return formatter.toDate(value);
};

class RenderContactCards extends Component {
  render() {
    const { fields, contactCards } = this.props;

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_contact_information"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((contact_card, index) => (
            <div key={index}>
              <h4 style={{ lineHeight: '26px' }}>
                Contact Details #{index + 1}
                <IconButton
                  style={{
                    padding: 0,
                    verticalAlign: 'text-bottom',
                    width: 'none',
                    height: 'none',
                    float: 'right',
                    marginRight: '25px',
                  }}
                  onClick={() => fields.remove(index)}
                >
                  <DeleteIcon size={24} style={{ padding: 0 }} />
                </IconButton>
              </h4>

              <div className="row">
                <div className="row">
                  <div className="col-xs-12" style={{ marginBottom: '20px' }}>
                    <Field
                      name={`${contact_card}.contact_card_type`}
                      validate={[validator.required]}
                      component={OutlinedSelect}
                      label="Contact Type"
                      style={{
                        fontSize: '14px',
                        textAlign: 'left',
                        width: '100%',
                      }}
                    >
                      <MenuItem key="con_1" value="emergency">
                        Emergency
                      </MenuItem>
                      <MenuItem key="con_2" value="office">
                        Office
                      </MenuItem>
                    </Field>
                  </div>
                  <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <Field
                      name={`${contact_card}.email`}
                      type="text"
                      variant="outlined"
                      component={TextField}
                      validate={[validator.validEmail]}
                      label={'Email'}
                      style={{ fontSize: '14px', width: '100%' }}
                    />
                  </div>

                  <div className="col-sm-8" style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <Field
                      name={`${contact_card}.phone_number`}
                      type="text"
                      component={ReactPhoneInput}
                      validate={[validator.required, validator.validInternationalPhoneNumber]}
                      label={'Phone Number'}
                      style={{ fontSize: '14px', width: '100%' }}
                    />
                  </div>
                  <div className="col-sm-4" style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <Field
                      name={`${contact_card}.phone_number_extension`}
                      type="text"
                      component={TextField}
                      variant="outlined"
                      normalize={formatter.onlyNumbers}
                      format={formatter.onlyNumbers}
                      label={'Ext.'}
                      style={{ fontSize: '14px', width: '100%' }}
                    />
                  </div>
                </div>
                {contactCards[index].contact_card_type === 'office' && (
                  <div className="row">
                    <h5 style={{ lineHeight: '26px', color: 'rgba(0, 0, 0, 0.3)' }}>
                      Available Hours
                    </h5>
                    <div className="col-xs-12" style={{ padding: 0, marginTop: '-12px' }}>
                      <div className="col-sm-6">
                        <Field
                          name={`${contact_card}.business_hours_start`}
                          type="text"
                          component={TimePicker}
                          validate={validator.required}
                          format={parseTime}
                          textFieldStyle={{ fontSize: '14px', width: '100%' }}
                          style={{ fontSize: '14px' }}
                          label="Available From"
                        />
                      </div>
                      <div className="col-sm-6">
                        <Field
                          name={`${contact_card}.business_hours_end`}
                          type="text"
                          component={TimePicker}
                          validate={validator.required}
                          format={parseTime}
                          textFieldStyle={{ fontSize: '14px', width: '100%' }}
                          label="Available To"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}

          <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
            <FlatButton
              label="Add Additional Contact Details"
              type="button"
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{ color: 'white' }}
              onClick={() => {
                fields.push({});
              }}
            />
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

class ContactCards extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={{ textAlign: 'center', margin: '25px 0px 30px 0px' }}>Contact Information</h3>
        </div>

        <Field name="hasContactCard" component={formatter.RenderError} />
        <form onSubmit={handleSubmit}>
          <FieldArray
            name="contact_cards"
            component={RenderContactCards}
            contactCards={this.props.contactCards}
          />
        </form>

        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }
}

export default compose(
  connect((state) => ({
    contactCards: formValueSelector('add_property')(state, 'contact_cards'),
  })),
  reduxForm({
    form: 'add_property',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(ContactCards);
